import { Box } from '@mui/material';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types';
import { fade, makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Drawer from '@material-ui/core/Drawer';
import DealerLocations from './DealerLocations';
function TablePaginationActions(props:any) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event: any) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event: any) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event: any) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );    
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a: any, b: any, orderBy: any) {
    let aVal=a[orderBy];
    let bVal=b[orderBy];
    if (bVal < aVal) {
        return -1;
    }
    if (bVal  > aVal) {
        return 1;
    }

    return 0;
}

function getComparator(order: any, orderBy: any) {
    return order === 'desc'
        ? (a: any, b: any) => descendingComparator(a, b, orderBy)
        : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
    const stabilizedThis = array
        .map((el: any, index: any) => [el, index]);
    stabilizedThis.sort((a: any, b: any) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el: any) => el[0]);
}

const headCells = [
    { id: 'dmsDealerId', numeric: false, disablePadding: false, label: 'DMS-ID' },
    { id: 'name', numeric: false, disablePadding: false, label: 'Dealer' },
    { id: 'address', numeric: false, disablePadding: false, label: 'Address' },
    { id: 'servername', numeric: false, disablePadding: false, label: 'Server' },
    { id: 'dmsType', numeric: false, disablePadding: false, label: 'DmsType' },
    { id: 'dealerTimezone', numeric: false, disablePadding: false, label: 'Dealer Time Zone' },    
    { id: 'messageCount', numeric: true, disablePadding: false, label: 'Credit' },
    { id: 'lastResponse', numeric: false, disablePadding: false, label: 'SurveyResponse' },
    { id: 'verified', numeric: false, disablePadding: false, label: 'Verified' },
];

function EnhancedTableHead(props: any) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property: any) => (event: any) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props: any) => {
    return (
        <div></div>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};



export default function Dealer({search}:{search:string}) {
    const childDealerLocations = useRef() as any;
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([] as any);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [data, SetData] = useState([]);
    const [loading, setLoading] = useState('Please wait.. gathering data');
    const [editDealerID, SetEditDealerID] = useState(0);
    const [currentLocationRow, SetCurrentLocationRow] = useState([]);
    const [ChildDealerSurvey, SetChildDealerSurvey] = useState([] as any);
    const [showMenu, SetShowMenu] = useState(false);
    const [showMenuComponent, SetShowMenuComponent] = useState(false);
    const [showAllDealer, SetShowAllDealer] = useState(false);

    const [menuClickComponent, SetMenuClickComponent] = useState([] as any);

    let rowEventHandled = 0;

    function HandleMenuClick(query: string) { }
    
    function toggleMenu() { SetShowMenu(!showMenu); }

    function toggleMenuComponent() { SetShowMenuComponent(!showMenuComponent); }

    function GetData() {
        return [...data].filter(filterRow);
    }

    function ShowSurvey(id: any) {
    }

    function FindDealerName(id:any) {
        var items = data.filter((data: any) => {
            if (data.dmsDealerIdCrm == id) {
                return data
            }
        }) as any;
        let name = '';
        if (items.length > 0) {
            name = items[0].name + ' [' + id + ']';
        }
        else {
            name = 'All Dealers';

        }
        return name;
    }

    const handleDealerRowClick = (event: any, name: any, rowDealer: any) => {
        if (rowEventHandled == 1) {
            rowEventHandled = 0;
            return;
        };
        const selectedIndex = selected.indexOf(name);
        let newSelected:any = [];
        newSelected = newSelected.concat('' as any, name);
        SetEditDealerID(0);
        SetCurrentLocationRow([]);
        setSelected(String(newSelected));
        childDealerLocations.current.ShowDealerLocation(name, FindDealerName(name),rowDealer)
    };

    function filterRow(element: any) {
        const keys = Object.keys(element);
        for (let i = 0; i < keys.length; i++) {
            let cellValue = String(element[keys[i]]);
            if (cellValue.toLowerCase().includes(search.toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    useEffect(() => { 
        let url = 'https://target-crm-func-dealer-service-prod-002.azurewebsites.net/api/dealers/cloudportal-dealers/' + showAllDealer + '?code=DDP0vDIHxmHNJD/OAm5mqA4nK2NhbCnW2jr61rZ40XQaZXEP1R4icQ==&clientId=apim-target-crm-api-gateway-prod';
        fetch(url)
            .then(response => response.json())
            .then(data =>
                (
                    SetData(data),
                    setLoading('')
                )
            ).catch(error => alert('Error: ' + error));

    }, [showAllDealer]);


    useEffect(() => {
         let _showAllDealer=localStorage.getItem('showAllDealer');
        if(_showAllDealer!=null){
            SetShowAllDealer(_showAllDealer=="1"?true:false);
        }
    }, []);

    const handleRequestSort = (event: any, property: any) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event: any) => {
    };

    const handleShowAllDealer = () => {
        SetShowAllDealer(showAllDealer == true ? false : true);
         localStorage.setItem('showAllDealer', (showAllDealer == true ? "0" : "1"));
    };

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (name: string) => {
        return selected.indexOf(name) !== -1;
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (

        <div className={classes.root} >

            <div style={{ border: "0px solid red", display: "table", margin: "10px" }}>
                <div style={loading == '' ? { display: "none" } : {}}><h1>{loading}</h1></div>
                <Paper style={{ display: "table" }}>
                    <EnhancedTableToolbar numSelected={selected.length} />
                    <TableContainer>
                        <Table
                            className={'myTable2 ' + classes.table}
                            aria-labelledby="tableTitle"
                            size={dense ? 'small' : 'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={GetData().length}
                            />
                            <TableBody
                            >
                                {
                                    stableSort(GetData(), getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row:any, index:any) => {
                                            const isItemSelected = isSelected(row.dmsDealerIdCrm);
                                            const labelId = `enhanced-table-checkbox-${index}`;
                                            let xdate = new Intl.DateTimeFormat('en-US').format(new Date(row.lastResponse));
                                            let response = row.surveyResponses > 0 ? xdate + ' (' + row.surveyResponses + ')' : '';
                                            let date1 = new Date();
                                            let date2 = new Date(row.lastResponse);
                                            date1.setDate(date1.getDate() - 2);

                                            let reponseClass = row.surveyResponses > 0 ? 'myButton' : '';
                                            if (reponseClass != '') {
                                                reponseClass = date2 > date1 ? 'myButtonCurrent myButton' : 'myButton';
                                            }

                                            return (
                                                <TableRow
                                                    hover
                                                    onClick={(event) => handleDealerRowClick(event, row.dmsDealerIdCrm, row)}
                                                    role="checkbox"
                                                    aria-checked={isItemSelected}
                                                    tabIndex={-1}
                                                    key={row.dmsDealerIdCrm}
                                                    selected={isItemSelected}
                                                >
                                                    <TableCell style={{ minWidth: "50px" }}>{row.dmsDealerIdCrm}</TableCell>
                                                    <TableCell style={{ minWidth: "300px" }}>{row.name}&nbsp;<img style={row.isActive == true ? { display: "none" } : {}} src='https://icons.iconarchive.com/icons/awicons/vista-artistic/16/delete-icon.png' /></TableCell>
                                                    <TableCell style={{ minWidth: "350px" }}>{row.address}</TableCell>
                                                    <TableCell>{row.servername}</TableCell>
                                                    <TableCell>{row.dmsType}</TableCell>
                                                    <TableCell>{row.dealerTimezone}</TableCell>                                                    
                                                    <TableCell align="right">{row.messageCount}</TableCell>
                                                    <TableCell align="center"><a href='#' className='noTextDecoration' onClick={() => ShowSurvey(row.dmsDealerIdCrm)}><span className={reponseClass}>{response}</span></a></TableCell>
                                                    <TableCell><div style={{marginLeft:"15px"}}> {row.verified==1?<>&#x2713;</>:<>&#x292C;</>}</div></TableCell>
                                                </TableRow>
                                            );
                                        })}
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <div style={{ marginLeft: "auto", marginRight: "0px", border: "0px solid green", display: "flex", justifyContent: "flex-end" }} >
                    <table>
                        <tr>
                            <td>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={showAllDealer}
                                            onChange={handleShowAllDealer}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label="Show inactive Dealers"
                                />
                            </td>
                            <td>
                                
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 15, 20, 25]}
                                component="div"
                                count={GetData().length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />                                
                            </td>
                        </tr>
                    </table>
                    </div>



                </Paper>
                <DealerLocations ref={childDealerLocations} />
                <div>{ChildDealerSurvey}</div>
            </div>
            <Drawer anchor="left" open={showMenu} onClose={toggleMenu} onClick={toggleMenu}>
                <div>
                    <List>
                        <ListItem button key="Last Invoice" onClick={(event) => HandleMenuClick('LastInvoice')}  >
                            <ListItemText primary="Last Invoice" />
                        </ListItem>

                        {['All mail', 'Trash', 'Spam'].map((text, index) => (
                            <ListItem button key={text} >
                                <ListItemText primary={text} />
                            </ListItem>
                        ))}
                    </List>
                </div>
            </Drawer>
            <Drawer anchor="right" open={showMenuComponent} onClose={toggleMenuComponent}>
                <div>
                    {menuClickComponent}

                </div>
            </Drawer>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "white",
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        color: "white",
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        fontWeight: "bolder",
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));